var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomsIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.333,
    height: 20,
    viewBox: "0 0 29.333 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4,8a4,4,0,1,1,4,4A3.995,3.995,0,0,1,4,8ZM6.667,8A1.333,1.333,0,1,0,8,6.667,1.337,1.337,0,0,0,6.667,8ZM29.333,8V20H26.667V16h-24v4H0V0H2.667V13.333H13.333V2.667H24A5.332,5.332,0,0,1,29.333,8ZM26.667,8A2.675,2.675,0,0,0,24,5.333H16v8H26.667Z",
    fill: "#ad926f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomsIconActive);
export default __webpack_public_path__ + "static/media/roomsIcon-active.369e76e65f5e3db863557db4305cd23e.svg";
export { ForwardRef as ReactComponent };